var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 6,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3a3 3 0 116 0 3 3 0 01-6 0zM9 3a3 3 0 116 0 3 3 0 01-6 0zM0 3a3 3 0 116 0 3 3 0 01-6 0z",
    fill: "#7884A1"
  })));
}

export default SvgIconDots;